"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.aDocumentPermissions = exports.aDocumentVersion = exports.aDocument = exports.anAdditionalDossier = exports.aLegalDossier = exports.aDossier = exports.aDocumentType = exports.aDocumentEquivalence = exports.anOrganisation = exports.aVATIdentificationNumber = exports.aGroupNumberIdentificationNumber = exports.anIdentificationNumberMap = exports.anInteroperatedOrganisation = exports.anAddress = exports.generateUID = exports.documentTypesInDb = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _documents = require("../utils/documents");

var _country = require("../utils/country");

var _organisations = require("../utils/organisations");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var documentTypesInDb = [{
  code: 'REG_BUSINESS',
  documentTypeId: 1,
  name: 'Gewerbeanmeldung',
  parentCode: 'REGISTRATION',
  parentName: 'Registrierungsnachweis',
  validityPeriod: 12,
  gatheredByDepositor: true
}, {
  code: 'REG_COMPANY',
  documentTypeId: 2,
  name: 'Eintragung IHK',
  parentCode: 'REGISTRATION',
  parentName: 'Registrierungsnachweis',
  gatheredByDepositor: true
}, {
  code: 'REG_ARTISAN',
  documentTypeId: 3,
  name: 'Eintragung HWK',
  parentCode: 'REGISTRATION',
  parentName: 'Registrierungsnachweis',
  gatheredByDepositor: true
}, {
  code: 'INS_LIABILITY',
  documentTypeId: 4,
  name: 'Nachweis Haftpflichtversicherung',
  parentCode: 'INSURANCE',
  parentName: 'Versicherungsbescheinigung',
  gatheredByDepositor: true
}, {
  code: 'INS_LIA_POLICE',
  documentTypeId: 5,
  name: 'Haftpflichtversicherungspolice',
  parentCode: 'INSURANCE',
  parentName: 'Versicherungsbescheinigung',
  gatheredByDepositor: true
}, {
  code: 'EMPLOYEES',
  documentTypeId: 6,
  name: 'Nachweis Haftpflichtversicherung',
  parentCode: 'EMPLOYEES_LIST',
  parentName: 'Arbeitnehmerliste',
  gatheredByDepositor: true
}, {
  code: 'FR_COV',
  documentTypeId: 29,
  name: 'Attestation de vigilance',
  parentCode: 'COVERAGE',
  parentName: 'Attestation de vigilance',
  gatheredByDepositor: false
}, {
  code: 'COV_VIGI',
  documentTypeId: 27,
  name: 'Attestation Sociale de vigilance',
  parentCode: 'COVERAGE',
  parentName: 'Attestation de vigilance',
  gatheredByDepositor: false,
  aiValidationEnabled: true
}, {
  code: 'FR_PAY',
  documentTypeId: 36,
  name: 'Attestation Congés payés',
  parentCode: 'PAID_LEAVE',
  parentName: 'Attestation Congés payés et intempéries',
  gatheredByDepositor: false
}, {
  code: 'INS_RC_PRO',
  documentTypeId: 53,
  name: 'Assurance RC Professionnelle',
  parentCode: 'INSURANCE',
  parentName: 'Attestation d\'assurance',
  gatheredByDepositor: false
}, {
  code: 'TAX_INDEPENDENT',
  documentTypeId: 50,
  name: 'Attestation fiscale société indépendante',
  parentCode: 'INSURANCE',
  parentName: 'Attestation d\'assurance',
  gatheredByDepositor: false
}];
exports.documentTypesInDb = documentTypesInDb;

var generateUID = function generateUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    // eslint-disable-next-line no-bitwise
    var r = Math.random() * 16 | 0; // eslint-disable-next-line no-mixed-operators, no-bitwise

    var v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
};

exports.generateUID = generateUID;

var anAddress = function anAddress(custom) {
  return _objectSpread({
    addressLine: '119 rue francis de préssensé',
    city: 'Villeurbanne',
    department: 'Rhône',
    region: 'Rhône',
    postCode: '69001'
  }, custom);
};

exports.anAddress = anAddress;

var anInteroperatedOrganisation = function anInteroperatedOrganisation(custom) {
  return _objectSpread({
    masterPlatform: null,
    country: _country.COUNTRY.FRANCE,
    enabled: false
  }, custom);
};

exports.anInteroperatedOrganisation = anInteroperatedOrganisation;

var anIdentificationNumberMap = function anIdentificationNumberMap() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return Object.assign.apply(Object, [{}].concat(args));
};

exports.anIdentificationNumberMap = anIdentificationNumberMap;

var aGroupNumberIdentificationNumber = function aGroupNumberIdentificationNumber(value) {
  return (0, _defineProperty2.default)({}, _organisations.GROUP_NUMBER_CODE, value || '84230331');
};

exports.aGroupNumberIdentificationNumber = aGroupNumberIdentificationNumber;

var aVATIdentificationNumber = function aVATIdentificationNumber(value) {
  return (0, _defineProperty2.default)({}, _organisations.VAT_IDENTIFICATION_NUMBER_CODE, value || 'FR11842303315');
};

exports.aVATIdentificationNumber = aVATIdentificationNumber;

var anOrganisation = function anOrganisation(custom) {
  return _objectSpread({
    organisationId: 1002,
    fullName: 'Papier Craft',
    country: _country.COUNTRY.FRANCE,
    businessLine: 'CONSTRUCTION',
    address: anAddress(),
    registrationNumber: '84230331500018',
    depositor: true,
    groupId: 1,
    enabled: false,
    planSelected: true,
    interoperatedOrganisation: anInteroperatedOrganisation(),
    identificationNumbers: anIdentificationNumberMap(aGroupNumberIdentificationNumber(), aVATIdentificationNumber())
  }, custom);
};

exports.anOrganisation = anOrganisation;

var aDocumentEquivalence = function aDocumentEquivalence(custom) {
  return _objectSpread({
    rule: 'MULTIPLE'
  }, custom);
};

exports.aDocumentEquivalence = aDocumentEquivalence;

var aDocumentType = function aDocumentType(custom) {
  return _objectSpread({
    code: 'INS_RC_PRO',
    documentTypeId: 53,
    name: 'Assurance RC Professionnelle',
    parentCode: 'INSURANCE',
    parentName: 'Attestation d\'assurance',
    gatheredByDepositor: true,
    multiOccurrence: false,
    validityPeriod: null,
    designationMandatory: false,
    abstractType: false,
    hasExample: true,
    applicationLevel: 'GROUP',
    certifyingThirdPartyMandatory: 'REQUIRED',
    issuingThirdPartyMandatory: 'OPTIONAL',
    thirdPartyIdNumberMandatory: 'REQUIRED',
    onlyForProjectSubcontractor: false,
    collectableByMandate: true,
    equivalence: null,
    canBeAdded: true,
    dossier: 'BUSINESS',
    aiValidationEnabled: false
  }, custom);
};

exports.aDocumentType = aDocumentType;

var aDossier = function aDossier(custom) {
  return _objectSpread({
    type: 'BUSINESS',
    client: null,
    project: null,
    business: 'CONSTRUCTION'
  }, custom);
};

exports.aDossier = aDossier;

var aLegalDossier = function aLegalDossier(custom) {
  return _objectSpread(_objectSpread({}, aDossier({
    type: 'LEGAL'
  })), custom);
};

exports.aLegalDossier = aLegalDossier;

var anAdditionalDossier = function anAdditionalDossier(custom) {
  return _objectSpread(_objectSpread({}, aDossier({
    type: 'ADDITIONAL'
  })), custom);
};

exports.anAdditionalDossier = anAdditionalDossier;

var aDocument = function aDocument(custom) {
  return _objectSpread({
    uid: generateUID(),
    groupLevel: true,
    state: _documents.DOCUMENT_STATE.VALID,
    type: aDocumentType(),
    depositDate: '2019-04-25T13:35:13.424Z',
    organisations: [anOrganisation()],
    validityEnd: '2019-12-31T22:59:59.999Z',
    hasFile: true,
    md5: '92cac928300f34d64c7809eaaee4e10b',
    hasExcelFile: false,
    noticePeriodConfiguration: 'LOW',
    firstNoticePeriod: 15,
    secondNoticePeriod: 10,
    thirdNoticePeriod: 5,
    issueDate: '2019-01-17T00:00:00Z',
    validityStart: '2019-01-17T00:00:00Z',
    certifyingThirdParty: 'Wemind',
    issuingThirdParty: 'Wemind',
    thirdPartyIdNumber: null,
    rejectionReason: null,
    additionalDesignation: '',
    subjectToObligation: true,
    gatheredByDepositor: true,
    collectionMandateEnabled: false,
    toFillinOnline: false,
    toSignOnline: false,
    dossiers: [aDossier()],
    unpublished: false,
    correlationId: generateUID(),
    verificationCode: null,
    hasProofFile: false,
    referencePeriod: null,
    payroll: null,
    staff: null,
    withCapitalizationScheme: false,
    amountBankGuarantee: null,
    turnover: null,
    iban: null,
    bic: null,
    contributionRate: null,
    turnoverTwa: null,
    referenceYear: null,
    legacy: false,
    overallStatusDocument: false
  }, custom);
};

exports.aDocument = aDocument;

var aDocumentVersion = function aDocumentVersion(custom) {
  return _objectSpread(_objectSpread({}, aDocument()), {}, {
    hasAnotherOccurrenceInSameDossier: false
  }, custom);
};

exports.aDocumentVersion = aDocumentVersion;

var aDocumentPermissions = function aDocumentPermissions(custom) {
  return _objectSpread({
    canEditAdditionalDesignation: true,
    canSeeSignAction: true,
    canSign: true,
    canUpload: true,
    canUploadByMandate: true,
    canDownload: true,
    canDownloadExcel: true,
    canDownloadWithInvalidState: true,
    canDownloadProof: true,
    canDuplicate: true,
    canDelete: true,
    isBackOffice: true
  }, custom);
};

exports.aDocumentPermissions = aDocumentPermissions;
var documentTestUtils = {
  anAddress: anAddress,
  anOrganisation: anOrganisation,
  aDocumentEquivalence: aDocumentEquivalence,
  aDocumentType: aDocumentType,
  aDossier: aDossier,
  aLegalDossier: aLegalDossier,
  anAdditionalDossier: anAdditionalDossier,
  aDocument: aDocument,
  aDocumentVersion: aDocumentVersion,
  aDocumentPermissions: aDocumentPermissions,
  anInteroperatedOrganisation: anInteroperatedOrganisation
};
var _default = documentTestUtils;
exports.default = _default;
//# sourceMappingURL=testDocumentUtils.js.map